define('fukit/helpers/error.util',['require','exports','module','create-error'],function(require, exports, module) {
  var CreateError = require('create-error');

  var ErrorUtil = {
    PermissionError: CreateError('PermissionError'),
    ProductDeactivatedError: CreateError('ProductDeactivatedError'),

    hasSufficientPermissions: function(value) {
      return function(value) {
        if (!value) {
          return true;
        }
        if (value.options) {
          var errorThrown = value.options.errorThrown;
          if (errorThrown) {
            if (errorThrown.xhr.status === 403) {
              return false;
            }
            return true;
          }
        }
      };
    },
  };

  module.exports = ErrorUtil;
});

